// extracted by mini-css-extract-plugin
module.exports = {"state":"checkbox-module--state--dCG8R","checkbox":"checkbox-module--checkbox--3DZpa","label":"checkbox-module--label--1HpbK","labelText":"checkbox-module--labelText--1jRSZ"};